/* unplugin-vue-components disabled */import { render } from "./icon_win.vue?vue&type=template&id=26efb58d&scoped=true"
const script = {}

import "./icon_win.vue?vue&type=style&index=0&id=26efb58d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26efb58d"]])

export default __exports__